import { Component, Input, OnInit } from '@angular/core';
import { IDashboardMidwifePayload, IReview } from 'src/app/models/dashboard.models';

@Component({
  selector: 'app-reviews-and-ratings',
  templateUrl: './reviews-and-ratings.component.html',
  styleUrls: ['./reviews-and-ratings.component.scss']
})
export class ReviewsAndRatingsComponent implements OnInit {

  @Input() midwife: IDashboardMidwifePayload;
  progressTitle: Array<string> = [];
  progressPercent: number;
  ratingProgressBar: any = {}
  reviews: Array<IReview> = [];

  constructor() { }

  ngOnInit(): void {
    this.progressTitle.push(String(this.midwife.rating));
    this.progressPercent = this.midwife.rating * 100 / 5;
    this.ratingProgressBar = {
      rating1: this.midwife.reviewSummary.rating1Count * 100 / this.midwife.reviewSummary.total,
      rating2: this.midwife.reviewSummary.rating2Count * 100 / this.midwife.reviewSummary.total,
      rating3: this.midwife.reviewSummary.rating3Count * 100 / this.midwife.reviewSummary.total,
      rating4: this.midwife.reviewSummary.rating4Count * 100 / this.midwife.reviewSummary.total,
      rating5: this.midwife.reviewSummary.rating5Count * 100 / this.midwife.reviewSummary.total
    }
    if(this.midwife.reviews)
    {
      this.reviews = this.midwife.reviews.slice(0,4);
    }
  }

  progressBarCss(progress: any){
    if(progress > 60)
    {
      return 'bg-success';
    }else if(progress > 20 && progress <=60)
    {
      return 'bg-warning';
    }
    else{
      return 'bg-danger';
    }
  }

}
